import { useQuery, useQueryClient } from "@tanstack/react-query";
import API from "@src/API";
import { queryKeys } from "./keys";

async function fetchPersonNotices() {
  const resp = await API.getAsync("/Person/Notices");
  if (!resp?.ok) {
    throw new Error(resp?.jsonData?.message || resp?.jsonData?.error || "Could not load notices");
  }
  const data = resp.jsonData || {};
  return {
    personNotices: Array.isArray(data.personNotices) ? data.personNotices : [],
  };
}

export function usePersonNoticesQuery(options = {}) {
  return useQuery({
    queryKey: queryKeys.personNotices(),
    queryFn: fetchPersonNotices,
    staleTime: 0,
    refetchOnMount: "always",
    ...options,
  });
}

export async function refreshPersonNotices(queryClient) {
  await queryClient.invalidateQueries({ queryKey: queryKeys.personNotices() });
  await queryClient.refetchQueries({ queryKey: queryKeys.personNotices() });
}

export async function resolvePersonNotice(noticeId) {
  const id = Number(noticeId);
  if (!(id > 0)) throw new Error("Invalid notice");
  const resp = await API.postAsync(`/Person/Notice/${id}/Resolve`, {});
  if (!resp?.ok) {
    throw new Error(resp?.jsonData?.message || resp?.jsonData?.error || "Could not resolve notice");
  }
  return resp.jsonData;
}

export function useRefreshPersonNotices() {
  const queryClient = useQueryClient();
  return () => refreshPersonNotices(queryClient);
}
